import { Component, inject, OnChanges, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchTab } from '@aipb/gulliver/catalog/model';
import { Observable } from 'rxjs';
import { CoreFieldInfoLang, RegisterStats } from '@aipb/gulliver/castor/model';
import { FieldRepository } from '@aipb/gulliver/castor/data-access';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { TranslocoPipe } from '@jsverse/transloco';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FacetService, SearchService } from '@aipb/gulliver/catalog/data-access';
import { FacetBaseComponent } from '../facet-base.component';

@Component({
  selector: 'cat-facet-statistics',
  standalone: true,
  imports: [CommonModule, MatRadioGroup, MatRadioButton, TranslocoPipe, MatButtonModule, MatIcon, ReactiveFormsModule],
  templateUrl: './facet-statistics.component.html',
  styleUrl: './facet-statistics.component.scss'
})
export class FacetStatisticsComponent extends FacetBaseComponent implements OnInit, OnChanges {
  registerFields$: Observable<CoreFieldInfoLang[]>;

  form: FormGroup = new FormGroup({});
  status: { [key: string]: boolean } = {};
  private fieldRepository = inject(FieldRepository);
  private searchService = inject(SearchService);
  private facetService = inject(FacetService);

  ngOnInit(): void {
    this.registerFields$ = this.fieldRepository.selectRegister(this.searchItem.coreId);

    this.form.valueChanges.subscribe((value) => {
      this.searchService.updateFacetStatResultCount(
        this.searchItem,
        this.facetService.getFacetStatQuery(this.searchItem.id, value)
      );
    });
  }

  ngOnChanges() {
    if (!this.facetItem) return;

    for (const item of Object.keys(this.facetItem.facets)) {
      if (this.form.contains(item)) continue;

      this.form.setControl(item, new FormControl(null));
    }

    for (const item of Object.keys(this.facetItem.facets)) {
      if (item in this.status) continue;

      this.status = {
        ...this.status,
        [item]: false
      };
    }
  }

  isExpanded(key: string) {
    if (key in this.status) {
      return this.status[key];
    }
    return false;
  }

  toggleExpand(key: string) {
    this.status = {
      ...this.status,
      [key]: key in this.status ? !this.status[key] : true
    };
  }

  getStats(fieldId: string): RegisterStats {
    if (!this.facetItem || !(fieldId in this.facetItem.facets)) return null;

    return this.facetItem.facets[fieldId].stat;
  }

  onSearch() {
    const query = this.facetService.getFacetStatQuery(this.searchItem.id, this.form.value);

    const searchTab: SearchTab = {
      solrSearchParams: {
        query: query,
        coreId: this.searchItem.coreId,
        sort: this.searchItem.search_sort
      },
      settings: {}
    };

    this.searchService.addTab(searchTab, true);
  }

  onReset() {
    const value = this.form.value;

    for (const key of Object.keys(value)) {
      value[key] = null;
    }

    this.form.patchValue(value);
  }
}
